<template>
  <section class="couponList">
    <header-com/>
    <tabCom :tabData="navData"
        :activeIndex="activeIndex"
        @changeTab='changeTab'
        class='top'
        />
    <ul v-if='couponList.length != 0'>
      <li v-for="(item, index) in couponList" :key="index"
        :style="{'backgroundImage':'url(/images/my/' + getItem(item).backgroundImg+'.png)'}">
        <div class="inner">
          <h3 class="couponTitle" v-html="getItem(item).title"></h3>
          <h4 class="f24 describe">{{item.description}}</h4>
          <!-- <h5 class="f20 grey6">满180元可使用，适用包包数量1个</h5> -->
          <time class="f20 grey9 time">{{item.startTime.split(' ')[0]}} 至 {{item.endTime.split(' ')[0]}}</time>
        </div>
      </li>
    </ul>
    <div v-else>
      <img src='/images/base/no_list_copunt.png' class='no-list'>

    </div>
  </section>
</template>

<script>
  import zhugeObj from '@/assets/js/track'
  import myApi from '@/axios/my'
  export default {
    name: 'couponList',
    components: {},
    data () {
      return {
        activeIndex : 0,
        navData: [
          {
            name: '未使用',
            type: 0
          },
          {
            name: '已使用',
            type: 1
          },
          {
            name: '已失效',
            type: 2
          }
        ],
        couponList: [

        ]
      }
    },
    watch: {},
    computed: {
    },
    created () {
      zhugeObj.track({
          title: "优惠券曝光"
      });
      this.getCoupon();
    },
    mounted () {
    },
    methods: {
      changeTab(index){
        this.activeIndex = index;
        this.getCoupon();
      },
      getCoupon(){
        let state = 10;
        if(this.activeIndex == 0){
          state = 10;
        }else if(this.activeIndex == 1){
          state = 20;
        }else{
          state = 90;
        }
        
        let params = {
          state : state,
          size : 99999,
          current : 1
        }

        myApi.getCoupon(params).then((res)=>{
          
          this.couponList = res.records;
        })
      },
      getItem (item) {
        let backgroundImg = '', title = ''
          switch (0) {
            // 0:满减 1:打折 2:礼物
            case 0:
              backgroundImg = 'coupon_mask1'
              title = '88<span class="aa">元</span>'
              break
            case 1:
              backgroundImg = 'coupon_mask2'
              title = '8.8<span class="aa">折</span>'
              break
            case 2:
              backgroundImg = 'coupon_mask3'
              title = '赠品'
              break
          }
          // 0:不能使用 1:可以使用
          if (this.activeIndex == 1) {
            backgroundImg += '.1'
          }
          return { backgroundImg: backgroundImg, title: item.couponName }
      }
    }

  }
</script>

<style lang="scss" scoped>
.describe{

  margin-top:10px;
}
.time{
  display: inline-block;
  margin-top: 15px;
}
.no-list{
    width:100%;
    margin-top: 300px;
}
.top{
  position: fixed;
  top:20px;
  display: flex;
  width: 80%;
  align-items: center;
  right: 10%;
  z-index: 101;

}
.couponList{
  padding: 100px 0 0;
  ul{
    li{
      height: 200px;
      padding: 20px;
      margin-bottom: -20px;
      /*border-radius:100px;*/
      background: no-repeat left top;
      background-size: 100%;
      .inner{
        width: 420px;
        padding: 6px 40px 0;
      }
      h3{
        font-size: 38px;font-weight: bold;
        line-height: 84px;
      }
      h4{line-height: 34px}
      h5,time{line-height: 28px}
    }
  }
}
</style>
<style>
  .couponList ul h3 span{
    font-size: 32px
  }
  .couponTitle{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all
  }
</style>
